// BurnStats — "🔥 R₿L Burn Stats" block on /shadow/tokens (below the
// tokenomics dashboard). Polls /api/burn/stats every 30s.
import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { API } from "../../lib/api";
import { useLanguage } from "../../i18n/LanguageContext";
import { tBurn } from "../../i18n/burn";
import BurnTicker from "./BurnTicker";
import BurnFeed from "./BurnFeed";

export default function BurnStats() {
  const { lang } = useLanguage();
  const t = (k) => tBurn(lang, k);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetch(`${API}/burn/stats`)
        .then((r) => r.json())
        .then((d) => alive && setStats(d))
        .catch(() => {});
    load();
    const id = setInterval(load, 30_000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  return (
    <div className="rounded-2xl border border-orange-400/20 bg-gradient-to-br from-orange-500/[0.05] to-transparent p-5 backdrop-blur" data-testid="burn-stats">
      <h3 className="flex items-center gap-2 text-sm font-medium text-white">
        <Flame className="h-4 w-4 animate-pulse text-orange-400" /> R₿L {t("burnStats")}
      </h3>
      <div className="mt-4 grid gap-6 md:grid-cols-2">
        <BurnTicker stats={stats} />
        <BurnFeed burns={stats?.recent_burns} />
      </div>
    </div>
  );
}
